module.exports = __webpack_public_path__ + "img/120.2.c7763c5e.png";